import { Box, Card, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Slide, Switch, Tooltip } from "@mui/material"
import { BeachAccess, ChildCare, Close, EventAvailable, EventBusy, LocalHospital, MoneyOff, Send } from "@mui/icons-material";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialInput from "../../../../components/MaterialInput";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useContext, useEffect, useState } from "react";
import UserDetailsContext from "../../../../context/auth";
import BASEURL from "../../../Utils/Baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { Allleaveconfigquery } from "../../../LeaveConfiguration/GraphQl";
import { useLoading } from "../../../../context/loading";
import { useNavigate } from "react-router-dom";
import { createLeaveRequest, deleteLeaveRequest, editLeaveMutation, getEmployeeDorDetailsQuery, getLeaveBalanceOfUser, getLeaveDataById, LeaveDetailOptions } from "./leaveData";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import "../customDialog/index.css"

const ApplyLeaveDialog = ({
  leaveId,
  viewScreen,
  leaveDialogOpen,
  setLeaveDialogOpen,
  selectedDate
}) => {
  
  const alldata = sessionStorage.getItem("user");
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();
  const { user, leavedisplay, AccessData } = useContext(UserDetailsContext);
  let userdata = JSON.parse(alldata);
  const TeamLeaderId = userdata?.teamleader;
  
  const [id, setId] = useState(leaveId || "");
  const [display, setdisplay] = useState(false);
  const [showLeaveType, setShowLeaveType] = useState(true);
  const [displayForm, setDisplayForm] = useState(false);
  
  const [filename, setfilename] = useState("");
  const [AllLeave, setAllLeave] = useState([]);
  const [Finalresult, setFinalresult] = useState("");
  const [leaveOptions, setLeaveOptions] = useState([]);
  const [originalleavedatas, setOriginalLeaveDatas] = useState(null);
  const [dorOptions, setDorOptions] = useState([]);
  const [primaryDorOptions, setPrimaryDorOptions] = useState([]);
  const [secondaryDorOptions, setSecondaryDorOptions] = useState([]);
  const[duration,setduration] = useState([
    { value:"First Half", label:"First Half"},
    { value:"Second Half",  label:"Second Half",}
  ]);
  //Icons for each Leave Type
  const iconMap = {
    sick_leave: <LocalHospital color="dark" fontSize="large"/>,
    casual_leave: <BeachAccess color="dark" fontSize="large"/>,
    loss_of_pay: <MoneyOff color="dark" fontSize="large"/>,
    maternity_leave: <ChildCare color="dark" fontSize="large"/>,
    earned_leave: <EventAvailable color="dark" fontSize="large"/>,
    restricted_holiday: <EventBusy color="dark" fontSize="large"/>
  };
  const initialLeaveData = {
    requestedOn: new Date().toISOString().split("T")[0],
    leaveType: "",
    leaveFrom: selectedDate,
    leaveTill: "",
    duration: "",
    halfDay: false,
    reason: "",
    primaryDor: "",
    secondaryDor: "",
    followUpTasks: "",
    totalDays: "",
    file: "",
    dateError: "",
    leaveTillError: "",

    fileStatus: "unchecked",
    requestedOnStatus: "unchecked",
    leaveTypeStatus: "unchecked",
    leaveFromStatus: selectedDate ? "success" : "unchecked",
    leaveTillStatus: "unchecked",
    reasonStatus: "unchecked",
    durationStatus: "unchecked",
    primaryDorStatus: "unchecked",
    secondaryDorStatus: "unchecked",
    followUpTasksStatus: "unchecked",
    totalDaysStatus: "unchecked",
  };

  const [leaveData, setLeaveData] = useState(initialLeaveData);
  
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });

  useEffect(() => {
    if (selectedDate) {
      
      setLeaveData(prev => ({
        ...prev,
        leaveFrom: selectedDate,
        leaveFromStatus: "success",
      }));
    }
  }, [leaveDialogOpen]);
  
  useEffect(() => {
    if(leaveDialogOpen){
      setCirleLoading(true);
      const runAllAPI = async () => {
        await Promise.allSettled([
          getleavetype(),
          allLeavedata(),
          getDor(),
        ]);
        setCirleLoading(false);
      };
      runAllAPI();
      setShowLeaveType(true);
      setDisplayForm(false);
    }
  }, [leaveDialogOpen]);

  useEffect(() => {
    if (leaveData.leaveFrom && leaveData.leaveTill) {
      let date1 = new Date(leaveData.leaveFrom);
      let date2 = new Date(leaveData.leaveTill);
      let Difference_In_Time = date2.getTime() - date1.getTime();
      let Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
      let Total_Days = Days + 1;
      if (leaveData.halfDay && Finalresult[0]?.halfDayAllowed) {
        setLeaveData((prev) => ({
          ...prev,
          totalDays: Total_Days - Total_Days * 0.5,
        }));
      } else {
        setLeaveData((prev) => ({
          ...prev,
          totalDays: Total_Days,
        }));
      }
    }
  }, [leaveData.leaveFrom, leaveData.leaveTill, leaveData.halfDay, leaveData.leaveType, Finalresult]);

  //Yet to be Implemented View Screen
  useEffect(() => {
    if(viewScreen){
      handleGetLeavesById(id);
    }
  },[viewScreen]);

  // QUERIES
      //Leave Type Query Function
  const getleavetype = async () => {
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: getLeaveBalanceOfUser,
          variables: { userId: user?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data.data.leaveBalanceByUser;

      let filterdata = data.filter((val)=> val.active == true)
      const formattedOptions = filterdata
        .filter((item) => {
          const leaveType = item?.leaveType;

          if (!leaveType || leaveType === "work_from_home") {
            return false;
          }

          if (leaveType === "paternity_leave") {
            return (
              userdata.gender === "Male" &&
              userdata.matural_status === "Married"
            );
          }

          if (leaveType === "maternity_leave") {
            return (
              userdata.gender === "Female" &&
              userdata.matural_status === "Married"
            );
          }
          if (leaveType === "adoption_leave") {
            return userdata.gender === "Female";
          }
          if (leaveType === "surrogacy_leave") {
            return userdata.gender === "Female";
          }

          return true;
        })
        .map((item) => ({
          value: item.id,
          label: item.leaveType.replace(/_/g, " ").toUpperCase(),
          mainvalue: item.leaveType,
        }));

      let resultdata = formattedOptions.filter(
        (val) => val.label != "WORK FROM HOME"
      );

      const temp = [];
      filterdata?.map((item) => {
        const leaveType = item?.leaveType;

        if (leaveType !== "loss_of_pay" && leaveType !== "work_from_home") {
          if (leaveType === "paternity_leave") {
            if (
              userdata.gender === "Male" &&
              userdata.matural_status === "Married"
            ) {
              temp.push(item);
            }
          } else if (leaveType === "maternity_leave") {
            if (
              userdata.gender === "Female" &&
              userdata.matural_status === "Married"
            ) {
              temp.push(item);
            }
          } else if (leaveType === "adoption_leave") {
            if (userdata.gender === "Female") {
              temp.push(item);
            }
          } else if (leaveType === "surrogacy_leave") {
            if (userdata.gender === "Female") {
              temp.push(item);
            }
          } else {
            temp.push(item);
          }
        }
      });

      setLeaveOptions(formattedOptions);
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
      //Leave Data Query Function
  const allLeavedata = async () => {
      try {
        setPageState({ ...pageState, loading: true });
  
        const response = await axios.post(
          BASEURL,
          {
            query: Allleaveconfigquery,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        const data = response.data.data.allLeaveConfigurations;        
        setAllLeave(data);
      } catch (error) {
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message: error.message,
          showCancel: true,
          showConfirm: false,
  
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
  };
      //DOR Query Function
  const getDor = async () => {
      const department = sessionStorage.getItem("user");
      const empId = JSON.parse(sessionStorage.getItem("user"));
      const deapartmentData = JSON.parse(department);
  
      const query = `

      `;
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: getEmployeeDorDetailsQuery,
            variables: {
              department: deapartmentData.department,
              id: empId.id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        if (response.data?.data?.getEmployeesByDepartment) {
          const formattedDorOptions =
            response.data.data.getEmployeesByDepartment.map((item) => ({
              value: item.id,
              label: item.firstName + " " + item.lastName,
            }));
  
          setDorOptions(formattedDorOptions);
          setPrimaryDorOptions(formattedDorOptions);
          setSecondaryDorOptions(formattedDorOptions);
        }
      } catch (error) {
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message: error.message,
          showCancel: true,
          showConfirm: false,
  
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
  };

  //Get Leave Data Function Yet to be implemented
  const handleGetLeavesById = async (id) => {
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: getLeaveDataById,
            variables: { id },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        const data = response.data;
  
        if (response.data.errors) {
          console.error("GraphQL Errors:", response.data.errors);
          return;
        }
  
        const leaveDatass = data.data.getLeaveById?.data[0];
        
        const fileterdata = leaveOptions.filter(
          (val) => val.label === leaveDatass.leaveType.leaveType
        );
  
        const selectedLeaveType =
          LeaveDetailOptions.find(
            (opt) => opt.value === leaveDatass.leaveType.leaveType
          ) || "";
  
        setLeaveData({
          ...leaveData,
          leaveType: {
            id: leaveDatass.leaveType.id,
            value: leaveDatass.leaveType.name
              .replace(/_/g, " ")
              .toUpperCase(),
            label: leaveDatass.leaveType.name
              .replace(/_/g, " ")
              .toUpperCase(),
          },
          duration:{value:leaveDatass?.halfDayDuration,label:leaveDatass?.halfDayDuration},
          requestedOn: leaveDatass?.requestedOn,
          leaveFrom: leaveDatass?.leaveFrom,
          leaveTill: leaveDatass?.leaveTill,
          reason: leaveDatass?.reason,
          primaryDor: leaveDatass?.primaryDor ? {value :leaveDatass?.primaryDor?.id
              , label : leaveDatass?.primaryDor?.firstName + ' ' + leaveDatass?.primaryDor?.lastName
          } : "",
          //if secondary DOR is same as primary DOR then set it to empty string, else set it to the secondary DOR
          secondaryDor: (leaveDatass?.secondaryDor?.id !== leaveDatass?.primaryDor?.id) ? { value: leaveDatass?.secondaryDor?.id, label: leaveDatass?.secondaryDor?.firstName + " " + leaveDatass?.secondaryDor?.lastName} : "",
          followUpTasks: leaveDatass?.followUpTasks || "",
          halfDay: leaveDatass?.halfDay,
        });
        setOriginalLeaveDatas({
          ...leaveDatass,
          leaveType: {
            value: leaveDatass.leaveType.leaveType,
            label: leaveDatass.leaveType.leaveType,
          },
        });
        setTogglePage({
          ...togglePage,
          view: true,
        });
      } catch (error) {
        console.error("ResponseError:", error.message);
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message: error.message,
          showCancel: true,
          showConfirm: false,
  
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
  };

    // CREATE
  const onLeaveRequestSubmit = async () => {
    setCirleLoading(true);

    let variables = {
      input: {
        userId: userdata.id,
        teamleaderId: TeamLeaderId || null,
        requestedOn: selectedDate || null,
        leaveType: leaveData.leaveType?.value || "",
        leaveFrom: leaveData.leaveFrom || null,
        leaveTill: leaveData.leaveTill,
        totalDays: parseFloat(leaveData.totalDays).toFixed(2) || null,
        halfDay: Finalresult[0]?.halfDayAllowed ? leaveData.halfDay : false,
        reason: leaveData.reason || null,
        primaryDor: leaveData.primaryDor?.value || null,
        secondaryDor:
          leaveData.secondaryDor?.value || leaveData.primaryDor?.value,
        followUpTasks: leaveData.followUpTasks || "",
        screenName: "Leave Approval",
        attachment: leaveData.file,
        halfDayDuration: leaveData.duration?.value || null,
      },
    };

    try {
      const response = await client.mutate({
        mutation: createLeaveRequest,
        variables: variables,
      });

      let Val = response?.data?.addleaveApproval;

      if (Val !== null && Val !== undefined) {
        let result = Val.leaveApproval;
        if (result !== null) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Leave Submitted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          handleCloseLeave();
          // navigate("/leave-management");
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      } else if (response?.data?.errors && response.data.errors.length > 0) {
        if (
          response.data.errors[0]?.message ===
          "You already have a pending or approved leave/work-from-home request for the selected dates."
        ) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: response.data.errors[0]?.message,
            showConfirmButton: false,
            timer: 5500,
          });
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      } else {
        console.error("Unexpected response structure:", response);
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Failed to submit leave request.",
          showConfirmButton: false,
          timer: 3000,
        });
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      }
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

    // EDIT
    const LeaveEditRequest = async () => {
      setCirleLoading(true);
  
      const fileterdata = leaveOptions.filter(
        (val) => val.label === leaveData.leaveType.label
      );
  
  
      const variables = {
        id: id,
        input: {
          leaveFrom: leaveData.leaveFrom,
          leaveTill: leaveData.leaveTill,
          teamleaderId: TeamLeaderId,
          leaveType: fileterdata[0]?.value,
          totalDays: leaveData.totalDays,
          halfDay: Finalresult[0]?.halfDayAllowed ? leaveData.halfDay : false,
          reason: leaveData.reason || "",
          primaryDor: leaveData.primaryDor?.value,
          secondaryDor: leaveData.secondaryDor?.value,
          followUpTasks: leaveData.followUpTasks,
          halfDayDuration: leaveData.duration?.value || null,
        },
      };
  
      try {
        const response = await axios({
          url: BASEURL,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: JSON.stringify({
            query: editLeaveMutation,
            variables,
          }),
        });
  
        let result = response.data.data.UpdateLeaveRequest?.success;
        const message = response.data.data.UpdateLeaveRequest?.message       
       
          Swal.fire({
            position: "center",
            icon: result?"success":"error",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/leave-management");
        
  
        setCirleLoading(false);
      } catch (error) {
        setCirleLoading(false);
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message: error.message,
          showCancel: true,
          showConfirm: false,
  
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
    };

    // DELETE
  const onDeleteSubmitLeave = async () => {
    setCirleLoading(true);

    try {
      const response = await axios.post(BASEURL, {
        query: deleteLeaveRequest,
        variables: {
          id: id,
        },
      });

      if (response.data.data.DeleteLeaveRequest.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/leave-management");
      } else {
        console.error(
          "Error deleting Holiday:",
          response.data.data.deleteHoliday.message
        );
      }
      setCirleLoading(false);
    } catch (error) {
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // Delete Confirmation
  const onClickDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteSubmitLeave();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //  HANDLE
  const handleLeaveDatachange = (event, selectEvent) => {
    
    let leaveState = { ...leaveData };
    if (event?.target === undefined && selectEvent) {
      if (event?.target === undefined && selectEvent) {
        const validDropdowns = ["primaryDor", "secondaryDor"];
        if (validDropdowns.includes(selectEvent.name)) {
          const lengthRegex = /^[A-Za-z0-9\s]+$/;
          leaveState[selectEvent.name + "Status"] = lengthRegex.test(
            event?.label
          )
            ? "success"
            : "error";        
        leaveState[selectEvent.name] = event;
        }
      if (selectEvent.name === "primaryDor") {
        setSecondaryDorOptions(
          dorOptions.filter((i) => i.value !== event.value)
        );
      }

      if (selectEvent.name === "secondaryDor") {
        setPrimaryDorOptions(
          dorOptions.filter((i) => i.value !== event.value)
        );
      }
      setLeaveData(leaveState);
    }
      if (selectEvent.name === "leaveType") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");

        let dat = event?.mainvalue;
        let alldata = AllLeave.filter((item) => item.name == dat);
        setFinalresult(alldata);

        if (lengthRegex.test(event?.label) === true) {
          leaveState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      if(selectEvent.name === "duration"){
            if(event){
         leaveState[selectEvent.name+"Status"] = "success";
             }
            else{
                leaveState[selectEvent.name+"Status"] = "unchecked";
            }           
      }
      leaveState[selectEvent.name] = event;      
    } 
    
    else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "leaveFrom": {
          // applying date should not be bigger than minimum date and also should not be bigger than maximum date
          let minimumdatetoapply = null;
          let maximumdatetoapply = null;
          let success = false;

          const MS_PER_DAY = 24 * 60 * 60 * 1000;
          let applyingdate = new Date(); // today
          applyingdate.setHours(0, 0, 0, 0);

          if (!event.target.value) {
            leaveState[event.target.name + "Status"] = "unchecked";
            leaveState[event.target.name] = "";
            break;
          }

          let leavedate = new Date(event.target.value);
          if (isNaN(leavedate)) {
            leaveState[event.target.name + "Status"] = "error";
            leaveState["dateError"] = "Invalid leave date.";
            break;
          }
          leavedate.setHours(0, 0, 0, 0);

          // extracting maximum and minimum date to apply
          const minimumdays = Finalresult[0]?.applyBefore ?? 0;
          const maximumdays = Finalresult[0]?.applyAfter ?? 0;

          minimumdatetoapply = new Date(leavedate.getTime() - minimumdays * MS_PER_DAY);
          maximumdatetoapply = new Date(leavedate.getTime() + maximumdays * MS_PER_DAY);

          if (applyingdate <= minimumdatetoapply || applyingdate <= maximumdatetoapply) {
            success = true;
          }

          if (success) {
            leaveState[event.target.name] = event.target.value;
            leaveState[event.target.name + "Status"] = "success";
            leaveState["leaveTill"] = "";
            leaveState["leaveTillStatus"] = "unchecked";
          } else if (!success && event.target.value) {
            leaveState[event.target.name + "Status"] = "error";
            leaveState[event.target.name] = "";
            leaveState["dateError"] = `You are not allowed to take leave between ${minimumdatetoapply.toDateString()} and ${maximumdatetoapply.toDateString()}`;
            leaveState["leaveTill"] = "";
            leaveState["leaveTillStatus"] = "unchecked";
          } else {
            leaveState[event.target.name + "Status"] = "unchecked";
            leaveState[event.target.name] = "";
          }
        }
        break;

        case "leaveTill":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );

            const leaveFrom = new Date(leaveData.leaveFrom);
            const leaveTill = new Date(event.target.value);

            const dayDifference =
              Math.ceil((leaveTill - leaveFrom) / (1000 * 60 * 60 * 24)) + 1;

            if (dayDifference > Finalresult[0]?.maxConsecutiveDays) {
              // alert(
              //   `You can only apply for a maximum of ${Finalresult[0]?.maxConsecutiveDays} consecutive days.`
              // );
              leaveState[event.target.name + "Status"] = "error";
              leaveState["leaveTillError"] = `You can only apply for a maximum of ${Finalresult[0]?.maxConsecutiveDays} consecutive days.`
            } else if (dateLengthRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "reason":
          {
            const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

            if (descriptionRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "halfDay":
          {
            leaveState[event.target.name] = event.target.value;
            leaveState[event.target.name + "Status"] = event.target.checked
              ? "success"
              : "unchecked";
          }
          break;
        case "followUpTasks":
          {
            const descriptionRegex = new RegExp("^([\\s\\S]{1,100})$");

            if (descriptionRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        leaveState[event.target.name] = event.target.value;
      }
    }
    setLeaveData(leaveState);
  };

  const handleCloseLeave = () => {
    setLeaveDialogOpen(false);
    setTimeout(() => {
      setLeaveData(initialLeaveData);
    }, 2000);
    
    if(showLeaveType === true && displayForm === false){
      setShowLeaveType(true);  
      setDisplayForm(false);
    }
    else if(showLeaveType ===false && displayForm === true){
      setShowLeaveType(false);
      setDisplayForm(true);
    }
  };


  const formatForDateInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // invalid fallback
    return date.toISOString().split("T")[0];
  };


  const handlefileupload = (e) => {
    const file = e.target.files[0];
    setfilename(file.name);
    setLeaveData({
      ...leaveData,
      file,
      fileStatus: file ? "success" : "error",
    });
  };

  const handleEditData = () => {
    setdisplay(true);
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  //Leave Eligibity Function
  const canApplyLeaveOnDate = (leave, selectedDate) => {
    const MS_PER_DAY = 24 * 60 * 60 * 1000;
    if (!selectedDate) return false;

    const today = new Date(); today.setHours(0,0,0,0);
    const leavedate = new Date(selectedDate);
    if (isNaN(leavedate)) return false;
    leavedate.setHours(0,0,0,0);

    const minimumdays = leave?.applyBefore ?? 0;
    const maximumdays = leave?.applyAfter ?? 0;

    const minimumdatetoapply = new Date(leavedate.getTime() - minimumdays * MS_PER_DAY);
    const maximumdatetoapply = new Date(leavedate.getTime() + maximumdays * MS_PER_DAY);

    return (today <= minimumdatetoapply || today <= maximumdatetoapply);
  };
  //Leave Eligibility Filter Function
  const eligibleLeaves = (leaveOptions || []).filter(l =>
    canApplyLeaveOnDate(l, selectedDate)
  );

  //Validation for all fields
  const checkAllFields = () => {
      let allowSubmit = false;
      if (
        leaveData.leaveTypeStatus === "success" &&
        leaveData.leaveFromStatus === "success" &&
        leaveData.leaveTillStatus === "success" &&
        leaveData.reasonStatus === "success" &&
        leaveData.primaryDorStatus === "success"
      ) {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
      return allowSubmit;
  };

  return (
    <>
    {leaveDialogOpen && (
      <MaterialBox
        onClick={handleCloseLeave}
        sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0, 0, 0, 0.59)",
            zIndex: 2,
        }}
      />
    )}  
      <Slide
      timeout={1000}
      direction="right"
      in={leaveDialogOpen}
      mountOnEnter unmountOnExit>
        <MaterialBox 
        p={1}
        className="custom-dialog-box"
        open={leaveDialogOpen}
        onClose={(event, reason) => {
            if (reason !== 'backdropClick') handleCloseLeave();
        }}>
          {confirmationDialog.open && (
          <ConfirmationDialog
            open={confirmationDialog.open}
            title={confirmationDialog.title}
            message={confirmationDialog.message}
            showCancel={confirmationDialog.showCancel}
            showConfirm={confirmationDialog.showConfirm}
            customSection={confirmationDialog.customSection}
            onConfirm={confirmationDialog.onConfirm}
            onCancel={confirmationDialog.onCancel}
          />
        )}
        {/* Choose Leave Type */}
        {showLeaveType && (
          <MaterialBox>
            {/* Choice Tile */}
            <MaterialBox>
              <Grid2 container justifyContent="center">
                <Grid2 size={{xs:12}}>
                  <MaterialTypography>
                    Choose Leave Type
                  </MaterialTypography>
                </Grid2>
              </Grid2>
            </MaterialBox>
            {/* Choice Content */}
             <MaterialBox
              sx={{
                maxHeight: "70vh",
                overflowY: "auto",
              }}
            >
              <Grid2 container spacing={2} p={2}>
                {eligibleLeaves.length > 0 ? (
                  eligibleLeaves.map((leave, index) => (
                    <Grid2 key={index} size={{ xs: 12 }}>
                      <Card
                        variant="outlined"
                        raised
                        onClick={() => {
                          let dat = leave?.mainvalue;
                          let alldata = AllLeave.filter((item) => item.name == dat);
                          setFinalresult(alldata);

                          setLeaveData(prev => ({
                            ...prev,
                            leaveType: leave,           
                            leaveTypeStatus: "success",
                            leaveFrom: selectedDate,
                            halfDay: alldata[0]?.halfDayAllowed ? true : false,
                          }));
                          setDisplayForm(true);
                          setShowLeaveType(false);
                        }}
                        style={{
                          padding: "4px 8px",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          border: "1px solid #E0E0E0",
                          cursor: "pointer",
                        }}
                      >
                        <div style={{ minWidth: "32px", display: "flex", justifyContent: "center", color: "#0B1D51" }}>
                          {iconMap[leave.mainvalue] || <EventAvailable />}
                        </div>
                        <MaterialTypography variant="body1" fontWeight="medium">
                          {leave.label}
                        </MaterialTypography>
                      </Card>
                    </Grid2>
                  ))
                ) : (
                  <Grid2 size={{ xs: 12 }}>
                    <Card variant="outlined" raised style={{ padding: "12px", borderRadius: "10px", textAlign: "center" }}>
                      <MaterialTypography variant="body2" color="error">
                        No leave available for {new Date(selectedDate).toDateString()}.
                      </MaterialTypography>
                    </Card>
                  </Grid2>
                )}
              </Grid2>
            </MaterialBox>
          </MaterialBox>
        )}
          {displayForm && (
              <>
            {/* Form Title */}
            <MaterialBox>          
              <Grid2 container alignItems="center">

                  {/* Title */}
                  <Grid2 size={{xs:10}} display="flex" justifyContent="center">
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Leave Form Applying for: {leaveData.leaveType?.label}
                    </MaterialTypography>
                  </Grid2>

                  <Grid2 size={{xs:2}} display="flex" justifyContent="flex-end">
                    {/* Edit button */}
                    {/* {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditLeave" && item.can_access
                      ) &&
                      leavedisplay && (
                      <Tooltip title="Edit" disableInteractive>
                        <IconButton
                          size="small"
                          disableElevation
                          color="success"
                          onClick={handleEditData}
                          sx={{color: "#757575"}}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )} */}

                    {/* Close button */}
                    <Tooltip title="Close" disableInteractive enterDelay={1200}>
                      <IconButton onClick={handleCloseLeave}>
                        <Close fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Grid2>
              </Grid2>
            </MaterialBox>
           
            {/* Form Content */}
            <MaterialBox p={1} sx={{   maxHeight: "72vh",overflowY: "auto", }}>
              <Grid2 container spacing={0.5}>
                <Grid2 size={{xs:6}}>
                  <MaterialBox>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Requested Date
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                  type="date"
                  value={leaveData?.requestedOn}
                  disabled
                  />
                </Grid2>
                {/* <Grid2 size={{xs:6}}>
                  <MaterialBox display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Leave Type <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                  name="leaveType"
                  filter
                  value={leaveData.leaveType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleLeaveDatachange}
                  options={leaveOptions}
                  error={leaveData.leaveTypeStatus === "error" ? true : false}
                  success={
                    leaveData.leaveTypeStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view === true ? true : false}/>
                </Grid2> */}
                <Grid2 size={{ xs: 6, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Leave From <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                  name="leaveFrom"
                  type="date"
                  value={formatForDateInput(leaveData.leaveFrom)}                    
                  onChange={handleLeaveDatachange}
                  error={leaveData.leaveFromStatus === "error" ? true : false}
                  success={
                    leaveData.leaveFromStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false || leaveData.leaveType !== "" ? false : true}
                />
                {leaveData.leaveFromStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>{leaveData.dateError}</FormHelperText>
                  </FormControl>
                  )
                }
                </Grid2>
                <Grid2 size={{ xs: 6, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Leave Till <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="leaveTill"
                    type="date"
                    inputProps={{ min: leaveData.leaveFrom }}
                    value={formatForDateInput(leaveData.leaveTill)}
                    onChange={handleLeaveDatachange}
                    error={leaveData.leaveTillStatus === "error" ? true : false}
                    success={ leaveData.leaveTillStatus === "success" ? true : false }
                    disabled={togglePage.view === true ? true : false || leaveData.leaveFrom !== "" ? false : true}
                  />
                  {leaveData.leaveTillStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>{leaveData.leaveTillError}</FormHelperText>
                    </FormControl>
                  )}
                </Grid2>
                <Grid2 size={{ xs: 6, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Total Days
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="reason"
                    placeholder="0"
                    value={leaveData.totalDays}
                    onChange={handleLeaveDatachange}
                    disabled
                  />
                </Grid2>
                {Finalresult[0]?.halfDayAllowed && (
                <Grid2 size={{ xs: 6, sm: 6 }}>
                  <MaterialBox
                    lineHeight={0}
                    display="inline-block"
                    sx={{ marginRight: "8px" }}
                  >
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Half Days
                    </MaterialTypography>
                  </MaterialBox>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={leaveData.halfDay}
                        onChange={(e) =>
                          handleLeaveDatachange({
                            target: {
                              name: "halfDay",
                              value: e.target.checked,
                            },
                          })
                        }
                        color="primary"
                      />
                    }
                    label={
                      <MaterialTypography variant="caption" fontWeight="bold">
                        {leaveData.halfDay ? "Yes" : "No"}
                      </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    disabled={togglePage.view}
                  />
                </Grid2>
              )}  
                {Finalresult[0]?.halfDayAllowed && leaveData.halfDay && (
                <Grid2 size={{ xs: 6, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Duration <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="duration"
                    filter
                    value={leaveData.duration}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleLeaveDatachange}
                    options={duration}
                    error={leaveData.durationStatus === "error" ? true : false}
                    success={
                      leaveData.durationStatus === "success" ? true : false
                    }
                    isDisabled={togglePage.view === true ? true : false}
                    isClearable
                  />
                </Grid2>
                )}
              
                {Finalresult[0]?.attachmentMandatory && (
                <Grid2 size={{xs:6}}>
                  <MaterialBox lineHeight={0} display="inline-block" mb={1}>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Upload the Document{" "}
                      <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <Box
                    component="label"
                    htmlFor="upload-file"
                    sx={{
                      border: "2px dashed #90caf9",
                      borderRadius: "12px",
                      padding: "10px 20px",
                      width: "100%",
                      minHeight: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      backgroundColor: "#f5faff",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                      },
                    }}
                  >
                    <CloudUploadIcon sx={{ fontSize: 30, color: "#2196f3" }} />
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Browse file to upload
                    </MaterialTypography>
                    <input
                      hidden
                      id="upload-file"
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handlefileupload}
                    />
                  </Box>
                  {leaveData?.fileStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Please upload a valid document (PDF, JPG, PNG).
                      </FormHelperText>
                    </FormControl>
                  )}

                  <FormHelperText>{filename}</FormHelperText>
                </Grid2>
                )}
                <Grid2 size={{xs:12}}>
                 <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Leave Reason <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="reason"
                    multiline
                    rows={2}
                    value={leaveData.reason}
                    onChange={handleLeaveDatachange}
                    error={leaveData.reasonStatus === "error"}
                    success={leaveData.reasonStatus === "success"}
                    disabled={togglePage.view === true ? true : false}
                  />
                  {leaveData.reasonStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Reason should be a minimum 10 characters & maximum 100
                        characters long.
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid2>
                <Grid2 size={{xs:6}}>
                  <MaterialBox>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Primary DOR <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="primaryDor"
                    value={leaveData.primaryDor}
                    options={primaryDorOptions}
                    onChange={handleLeaveDatachange}
                    success={
                      leaveData.primaryDorStatus === "success" ? true : false
                    }
                    error={leaveData.primaryDorStatus === "error" ? true : false}
                    menuPlacement="top"
                    // isDisabled={togglePage.view === true ? true : false}
                  />
                </Grid2>
                <Grid2 size={{xs:6}}>
                  <MaterialBox>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Secondary DOR
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="secondaryDor"
                    value={leaveData.secondaryDor}
                    options={secondaryDorOptions}
                    onChange={handleLeaveDatachange}
                    success={
                      leaveData.secondaryDorStatus === "success" ? true : false
                    }
                    error={
                      leaveData.secondaryDorStatus === "error" ? true : false
                    }
                    menuPlacement="top"
                    // isDisabled={togglePage.view === true ? true : false}
                  />
                </Grid2>       
                <Grid2 size={{xs:12}}>
                  <MaterialBox>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Follow up Tasks
                    </MaterialTypography>
                    <MaterialInput
                      name="followUpTasks"
                      value={leaveData.followUpTasks}
                      multiline
                      rows={2}
                      onChange={handleLeaveDatachange}
                      error={leaveData.followUpTasksStatus === "error"}
                      success={leaveData.followUpTasksStatus === "success"}
                      // disabled={togglePage.view === true ? true : false}
                    />
                  </MaterialBox>
                </Grid2>
              </Grid2>
            </MaterialBox>

            {/* Form Action */}
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center">
                {/* <MaterialBox>          
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "EditLeave" && item.can_access
                    ) &&
                    leavedisplay && (
                      <MaterialButton
                      variant="gradient"
                      color="error"
                      size="small"
                      onClick={onClickDelete}
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </MaterialButton>
                  )} 

                </MaterialBox> */}
                <MaterialBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center">
                      {!leavedisplay && (
                        <>
                          <MaterialButton
                            sx={{ m: 1, marginLeft: "4px" }}
                            variant="gradient"
                            color="dark"
                            size="small"
                            endIcon={<Send />}
                            disabled={!checkAllFields()}
                            onClick={onLeaveRequestSubmit}
                          >
                            Apply
                          </MaterialButton>
                        </>
                      )}
                      {display && (
                        <>
                          <MaterialButton
                            sx={{ m: 2, marginLeft: "4px" }}
                            variant="gradient"
                            color="dark"
                            size="small"
                            endIcon={<Send/>}
                            disabled={!checkAllFields()}
                            onClick={LeaveEditRequest}
                          >
                            Update
                          </MaterialButton>
                        </>
                    )}
                </MaterialBox> 
            </MaterialBox>  
            </>
          )}            
        </MaterialBox>
           
      </Slide>
    </>
  );
};


export default ApplyLeaveDialog